import Posthog from 'posthog-js';
import { _isEmpty } from '@epihub/core/src/fn/object';
import { type SupportedLanguage } from '@krishanmadan/core/src/model/const';
import { vars } from '../_ctx/vars';

class AnalyticsBase {
  constructor() {
    if (!_isEmpty(vars.posthog) && !_isEmpty(vars.posthog!.API_KEY)) {
      Posthog.init(vars.posthog!.API_KEY, { api_host: 'https://eu.i.posthog.com' });
    }
  }

  readonly identify = (
    user: {
      visitorId: string;
      name: string;
      language: SupportedLanguage;
    },
  ) => {
    return Posthog.identify(user.visitorId, {
      name: user.name,
      type: user.language,
    });
  };

  readonly reset = () => {
    return Posthog.reset();
  };
}

export const Analytics = new AnalyticsBase();
